import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { lastValueFrom, RmsMessageService } from '@services';
import { RmsModule } from '@rms';
import { RmsPulldownRef } from '../../../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';
import { RMS_PULLDOWN_DATA } from '../../../custom-modules/rms-module/rms-pulldown/rms-pulldown.tokens';
import { PaymentsDataService } from '../../../services/payments-data.service';

// =====================================================================
// OrderPaymentsPopupComponent — click on "Amount" (legacy "Order Payments")
// ---------------------------------------------------------------------
// Payments on one order (amount, date, method, bank, accounting stage),
// Total Paid / Left To Pay, and "Open Partial Pay Window".
// Closes with { openPartial: true } when that button is used — the parent
// opens PartialPaymentComponent.
// =====================================================================

@Component({
  selector: 'app-order-payments-popup',
  imports: [RmsModule],
  templateUrl: './order-payments-popup.component.html',
  styleUrl: './order-payments-popup.component.scss'
})
export class OrderPaymentsPopupComponent implements OnInit {
  Loading = true;
  Summary: any = null;
  Payments: any[] = [];

  constructor(
    @Inject(RMS_PULLDOWN_DATA) private data: { OrderID: number },
    public ref: RmsPulldownRef,
    private paymentsData: PaymentsDataService,
    private msg: RmsMessageService,
    private cdr: ChangeDetectorRef
  ) { }

  async ngOnInit() {
    try {
      const result = await lastValueFrom(this.paymentsData.getOrderPayments(this.data.OrderID));
      this.Summary = result?.Summary ?? null;
      this.Payments = result?.Payments ?? [];
    } catch (err: any) {
      this.msg.error(err?.error?.error ?? 'Could not load the payments for this order.');
    } finally {
      this.Loading = false;
      this.cdr.markForCheck();
    }
  }

  get canPayMore(): boolean {
    return !!this.Summary && !this.Summary.DatePaid && (this.Summary.LeftToProcess ?? 0) > 0.005;
  }

  openPartial() {
    this.ref.close({ openPartial: true });
  }

  close() {
    this.ref.close();
  }
}
